const APIs = {
  ANALYTICS_POSTS: 'admin/analytics/posts/:id/:alias',
  ANALYTICS_PUBLICATIONS: 'admin/analytics/publications/:id/:alias',
  ANALYTICS_REVENUE: 'admin/analytics/revenue',
  ANALYTICS_LAST_MONTH_STATS: 'admin/analytics/last-month-stats',
  //   ANALYTICS_PUBLICATIONS: 'admin/settings',
}
export default APIs
